import { useState } from 'react';
import type { PickerProps } from './types';

type Disposition = 'inline' | 'attachment';

function parse(value: string): { disposition: Disposition; filename: string } {
  const lower = value.toLowerCase();
  const disposition: Disposition = lower.startsWith('attachment') ? 'attachment' : 'inline';
  const match = /filename="?([^";]+)"?/.exec(value);
  return { disposition, filename: match?.[1] ?? '' };
}

function build(disposition: Disposition, filename: string): string {
  if (!filename) return disposition;
  return `${disposition}; filename="${filename}"`;
}

export function ContentDispositionPicker({ value, onChange }: PickerProps) {
  const initial = parse(value);
  const [disposition, setDisposition] = useState<Disposition>(initial.disposition);
  const [filename, setFilename] = useState<string>(initial.filename);

  const updateDisposition = (next: Disposition) => {
    setDisposition(next);
    onChange(build(next, filename));
  };

  const updateFilename = (next: string) => {
    setFilename(next);
    onChange(build(disposition, next));
  };

  return (
    <div className="picker-grid">
      <div className="picker-row">
        {(['inline', 'attachment'] as Disposition[]).map((d) => (
          <button
            key={d}
            className={disposition === d ? 'pill active' : 'pill'}
            onClick={() => updateDisposition(d)}
            type="button"
          >
            {d}
          </button>
        ))}
      </div>
      <input
        className="picker-input"
        placeholder="filename (optional)"
        value={filename}
        onChange={(e) => updateFilename(e.target.value)}
      />
    </div>
  );
}
